import React from 'react';

const iconMap = {
  '1.webp': require('club_product_v2/1.webp'),
  '2.webp': require('club_product_v2/2.webp'),
  '3.webp': require('club_product_v2/3.webp'),
  '4.webp': require('club_product_v2/4.webp'),
  '5.webp': require('club_product_v2/5.webp'),
  '6.webp': require('club_product_v2/6.webp'),
  '7.webp': require('club_product_v2/7.webp'),
  '8.webp': require('club_product_v2/8.webp'),
  '9.webp': require('club_product_v2/9.webp'),
  '10.webp': require('club_product_v2/10.webp'),
  '11.webp': require('club_product_v2/11.webp'),
  '12.webp': require('club_product_v2/12.webp'),
  'club.webp': require('club_product_v2/club.webp'),
  'log_out.webp': require('club_product_v2/log_out.webp'),
  'player_profile.webp': require('club_product_v2/player_profile.webp'),
  'settings.webp': require('club_product_v2/settings.webp'),
};

const defaultLogo = require('club_product_v2/GG-Icon.png');

const MobilePreview = ({ grouped, clubLogo, clubName }) => {
  const checkedCategories = grouped.filter(category => category.checked);
  const maxVisibleItems = 9;
  const hasMoreItems = checkedCategories.length > maxVisibleItems;

  return (
    <div className='col-md-5 show_area no_padding hidden-xs'>
      <fieldset className='mobile_dashboard_preview'>
        <div className='title_area'>
          <div className='text-center btsp_uppercase_text'>
            {window.I18n.t('mobile_app_dashboard.app_preview.mobile_app_preview')}
          </div>
        </div>
        <div className='content_area'>
          <div className='col-xs-12 more_margin_bottom text-center'>
            <div className='app_dashboard_preview_container' style={{ display: 'inline-block', position: 'relative' }}>
              <div className='club-logo-preview'>
                <img
                  src={clubLogo || defaultLogo}
                  alt='club_logo'
                  style={{ height: 60 }}
                  onError={(e) => { e.target.src = defaultLogo }}
                />
              </div>
              <span className='club-name-preview'>{clubName}</span>
              <div
                className="category-title-overlay"
                style={{
                  maxHeight: hasMoreItems ? 'calc(9 * 25px)' : 'auto',
                  overflowY: hasMoreItems ? 'scroll' : 'visible',
                }}
              >
                {checkedCategories.map((category, index) => {
                  let iconUrl = null;

                  if (category.uploaded_icon && category.uploaded_icon instanceof File) {
                    iconUrl = URL.createObjectURL(category.uploaded_icon);
                  } else if (category.uploaded_icon && category.uploaded_icon.url) {
                    iconUrl = category.uploaded_icon.square?.url || category.uploaded_icon.url;
                  } else if (category.icon) {
                    iconUrl = iconMap[category.icon];
                  }

                  return (
                    <div
                      key={category.id}
                      className="category-title"
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '8px',
                      }}
                    >
                      {iconUrl && <img src={iconUrl} alt="icon" style={{ width: 16, height: 16, flexShrink: 0 }} />}
                      <span style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                        {category.name}
                      </span>
                    </div>
                  );
                })}
              </div>
              <img src={require('club_product_v2/burger_menu.png')} alt="Mobile Preview" />
            </div>
          </div>
        </div>
      </fieldset>
    </div>
  );
};

export default MobilePreview;